import React from "react";
import TypographyContainer from "../../../../ui/layout/page/typography-container/typography-base-container";
import TypographyItemContainer from "../../../../ui/layout/page/typography-container/typography-item-container";
import ApplicationPageContent from "../../../../ui/layout/page/content/application";
import Typography from "../../../../ui/widgets/typography";
import { Box, Container } from "@mui/material";
import GridContainerItem from "../../../../ui/layout/page/container-item";
import ExceptionErrorImage from "../../../../resources/images/exception-illustration.svg";
import GridContainer from "../../../../ui/layout/page/container/GridContainer";

interface ExceptionPropTypes {
  title: string;
  description: string;
  renderButton?: () => React.JSX.Element;
}

export const Exception: React.FC<ExceptionPropTypes> = (
  props: ExceptionPropTypes,
) => {
  const { title, description, renderButton } = props;

  return (
    <ApplicationPageContent>
      <Container>
        <GridContainerItem>
          <Box textAlign="center" width="100%">
            <img src={ExceptionErrorImage} alt="Exception" />
          </Box>
        </GridContainerItem>
      </Container>

      <GridContainer justifyContent="center">
        <TypographyContainer>
          <TypographyItemContainer>
            <Typography align="center" variant="h2">
              {title}
            </Typography>
          </TypographyItemContainer>
        </TypographyContainer>
      </GridContainer>

      <TypographyContainer>
        <TypographyItemContainer>
          <Typography align="center" variant="subtitle1">
            {description}
          </Typography>
        </TypographyItemContainer>
      </TypographyContainer>

      {renderButton && (
        <GridContainer justifyContent="center">{renderButton()}</GridContainer>
      )}
    </ApplicationPageContent>
  );
};
